
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.02 23.433h11.983","fill":"none","stroke":"#000","stroke-width":"2.17","transform":"matrix(.83572 0 0 1 1.961 -.517)"}}),_c('path',{attrs:{"d":"M17.007 22.917l2.981-15.228H3.993l3 15.228M2.132 4.217H21.85v3.471H2.132zM5.744 15.303h12.511","fill":"none","stroke":"#000","stroke-width":"2"}}),_c('path',{attrs:{"d":"M6.993 5.217h10.014V1.946H6.993v3.271","fill":"none","stroke":"#000","stroke-width":"2.03","transform":"matrix(1.12881 0 0 .8172 -1.555 -.35)"}})])
          )
        }
      }
    